import AgentsAPI from 'dashboard/api/agents/agents';
import { createStore } from './storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const SET_TIERS = 'SET_AI_TIERS';
const SET_SYNCING = 'SET_AI_SYNCING';

export default createStore({
  name: 'AIAgents',
  API: AgentsAPI,
  state: () => ({
    tiers: [],
    syncing: false,
  }),
  getters: {
    getTiers: state => state.tiers,
    isSyncing: state => state.syncing,
    // Alias for getRecords - used by SubAgentSelector
    getAgents: state => state.records.sort((r1, r2) => r2.id - r1.id),
    getAgentsByTier: state => tier =>
      state.records.filter(agent => agent.tier === tier),
    getActiveAgents: state => state.records.filter(agent => agent.active),
    getLLMAgents: state =>
      state.records.filter(
        agent => agent.agent_type === 'llm' || !agent.agent_type
      ),
  },
  mutations: {
    [SET_TIERS](state, tiers) {
      state.tiers = tiers;
    },
    [SET_SYNCING](state, syncing) {
      state.syncing = syncing;
    },
  },
  actions: mutationTypes => ({
    getTiers: async ({ commit }) => {
      try {
        const response = await AgentsAPI.getTiers();
        commit(SET_TIERS, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },
    sync: async ({ commit }, { id }) => {
      try {
        commit(SET_SYNCING, true);
        const response = await AgentsAPI.sync(id);
        commit(mutationTypes.EDIT, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(SET_SYNCING, false);
      }
    },
    syncAll: async ({ commit }) => {
      try {
        commit(SET_SYNCING, true);
        const response = await AgentsAPI.syncAll();
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(SET_SYNCING, false);
      }
    },
  }),
});
